import Vue from "vue";
import Vuex from "vuex";
import module from "./module";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });
Vue.use(Vuex);
Vue.config.devtools = true;
const store = new Vuex.Store({
  state: {
    isMenuOpen: true,
    trackingOS: {},
    detailTRX: {},
    isLoading: false,
    showAlert:false,
    alertValues:{msg:'',variant:''},

  },
  getters: {

  },
  mutations: {
    SET_MENU_CLOSE(state, val) {
      state.isMenuOpen = val;
    },
 
    SET_DETAILS_TRX(state, val) {
      state.detailTRX = val;
    },

    SET_LOADING(state, val) {
      state.isLoading = val;
    },
    SET_SHOW_ALERT(state, val) {
      state.showAlert = val;
    },
    SET_MSG_RESPONSE(state,val){
      state.alertValues.msg = val.msg;
      state.alertValues.variant = val.variant;
    },
  },
  actions: {
  
  },
  modules: {
    module,
  },
  plugins: [
    createPersistedState({
      paths: ["module.tokenAuth", "module.username","module.optionsMenu"],
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
export default store;
const initialStateCopy = JSON.parse(JSON.stringify(store.state));

export function resetState() {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)));
}
